import { render, staticRenderFns } from "./DocumentDropZone.vue?vue&type=template&id=b67e59ec&scoped=true&"
import script from "./DocumentDropZone.vue?vue&type=script&lang=js&"
export * from "./DocumentDropZone.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDropZone.vue?vue&type=style&index=0&id=b67e59ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e59ec",
  null
  
)

export default component.exports